/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

/*========= MENU ==================*/

export default [
  {
    url: '/dashBoard',
    name: 'Dashboard',
    icon: 'HomeIcon',
    i18n: 'Dashboard',
  },
  {
    url: '/Associados',
    name: 'Associados',
    label: 'Beneficiários',
    slug: 'page2',
    icon: 'UserIcon',
  },
  {
    url: null,
    name: 'Propostas',
    slug: 'page2',
    icon: 'ArchiveIcon',
    submenu: [
      {
        url: '/novaProposta/Interno',
        name: 'Cotações',
        label: 'Nova Proposta',
        permission: 'Escrita',
        label: 'Nova Proposta',
        i18n: 'Checklist',
      },
      {
        url: '/Cotacoes',
        name: 'Cotações',
        label: 'Painel Propostas',
        i18n: 'Checklist',
      },
    ],
    hasBadge: true,
    keyBadge: 'cotacoes',
  },
  {
    url: '/Pre-Cotacoes',
    name: 'Pré Cotações',
    label: 'Pré Propostas',
    slug: 'page2',
    icon: 'ClockIcon',
  },
  {
    url: '/Vistorias',
    name: 'Vistorias',
    slug: 'page2',
    icon: 'CameraIcon',
    hasBadge: true,
    keyBadge: 'vistorias',
  },
  {
    url: null,
    name: 'Eventos',
    slug: 'page2',
    icon: 'Minimize2Icon',
    submenu: [
      {
        url: '/novo-evento',
        name: 'Eventos',
        permission: 'Escrita',
        label: 'Novo Evento',
        i18n: 'Novo Evento',
      },
      {
        url: '/eventos',
        name: 'Eventos',
        permission: 'Escrita',
        label: 'Painel Evento',
        i18n: 'Eventos',
      },
      {
        url: '/MotivosEvento',
        name: 'Motivo de Evento',
        i18n: 'Motivo de Evento',
      },
      {
        url: '/SituacoesEvento',
        name: 'Situação de Evento',
        i18n: 'Situação de Evento',
      },
    ],
  },
  {
    url: null,
    name: 'Cotações B2C',
    label: 'Propostas B2C',
    slug: 'page2',
    icon: 'CrosshairIcon',
    submenu: [
      {
        url: '/CotacoesB2C',
        name: 'Cotações B2C',
        label: 'Propostas B2C',
        i18n: 'Cotações B2C',
      },
      {
        url: '/PainelLeadsB2C',
        name: 'Painel de Leads B2C',
        i18n: 'Painel de Leads B2C',
      },
    ],
  },
  {
    url: '/Metas',
    name: 'Metas Por Regionais',
    slug: 'page2',
    icon: 'TrendingUpIcon',
  },
  {
    url: null,
    name: 'Financeiro',
    i18n: 'MenuLevel2p2',
    icon: 'DollarSignIcon',
    submenu: [
      {
        url: '/fechamento',
        name: 'Fechamento',
        i18n: 'Fechamento',
      },
      {
        url: '/PainelFinanceiro',
        name: 'Painel Financeiro',
        i18n: 'Painel Financeiro',
      },
      {
        url: '/ArquivoRemessa',
        name: 'Arquivo Remessa',
        i18n: 'Arquivo Remessa',
      },
      {
        url: '/ArquivoRetorno',
        name: 'Arquivo Retorno',
        i18n: 'Arquivo Retorno',
      },
      {
        url: '/Extrato',
        name: 'Extrato',
        i18n: 'Extrato',
      },
      {
        url: '/gestao-status',
        name: 'Gestão Status',
        i18n: 'Gestão Status',
      },
      {
        url: '/pagamentos-inconsistentes',
        name: 'Pagamentos Inconsistentes',
        i18n: 'Pagamentos Inconsistentes',
      },
    ],
  },
  /*=---------- RELACIONAMENTO ----------=*/
  {
    url: null,
    name: 'Relacionamento',
    i18n: 'MenuLevel2p2',
    icon: 'MessageSquareIcon',
    submenu: [
      {
        url: '/Cancelamentos',
        name: 'Cancelamento',
        i18n: 'Cancelamento',
      },
      {
        url: '/Ouvidoria',
        name: 'Ouvidoria',
        i18n: 'Ouvidoria',
      },
      {
        url: '/ChamadosInternos',
        name: 'Chamados Internos',
        i18n: 'Chamados Internos',
      },
    ],
  },
  /*=---------- ASSISTENCIA----------=*/
  {
    url: null,
    name: 'Assistência',
    i18n: '',
    icon: 'PhoneCallIcon',
    submenu: [
      {
        url: '/Checklist',
        name: 'Checklist',
        i18n: 'Checklist',
      },
    ],
  },
  {
    url: '/Chamado',
    name: 'Fale com Especialista',
    slug: 'page2',
    // icon: "MailIcon",
    icon: 'VoicemailIcon',
  },
  /*=---------- RELATORIOS ----------=*/
  {
    url: null,
    name: 'Relatórios',
    i18n: 'MenuLevel2p2',
    icon: 'BarChartIcon',
    submenu: [
      {
        url: '/Graficos/Crescimento',
        name: 'Crescimento',
        i18n: 'Crescimento',
      },
      {
        url: '/Graficos/Vendas',
        name: 'Vendas',
        i18n: 'Vendas',
      },
      {
        url: '/Graficos/Cancelamentos',
        name: 'Cancelamentos',
        i18n: 'Cancelamentos',
      },
      {
        url: '/Dinamicos',
        name: 'Dinamicos',
        i18n: 'Dinamicos',
      },
      {
        url: '/Consolidado',
        name: 'Consolidado',
        i18n: 'Consolidado',
      },
    ],
  },
  /*=---------- MARKETING ----------=*/
  {
    url: null,
    name: 'Marketing',
    i18n: 'MenuLevel2p2',
    icon: 'Share2Icon',
    submenu: [
      {
        url: '/marketing/painel-de-leads',
        name: 'Painel de Leads',
        i18n: 'Painel de Leads',
      },
    ],
  },

  /*========= MENU ADMINISTRADOR ==================*/
  {
    header: 'Administrador',
    i18n: 'Apps',
  },
  /*=---------- CADASTRO  ----------=*/
  {
    url: null,
    name: 'Cadastros',
    i18n: 'MenuLevel2p2',
    icon: 'PlusSquareIcon',
    submenu: [
      {
        url: '/empresa',
        name: 'Empresa',
        i18n: 'Empresa',
      },
      {
        url: '/usuarios',
        name: 'Usuário',
        i18n: 'Usuário',
      },
      {
        url: '/vistoriadores',
        name: 'Vistoriador',
        i18n: 'Vistoriador',
      },
      {
        url: '/divisoes',
        name: 'Divisão',
        i18n: 'Divisão',
      },
      {
        url: '/regionais',
        name: 'Regional',
        i18n: 'Regional',
      },
      {
        url: '/setores',
        name: 'Setor',
        i18n: 'setor',
      },
      {
        url: '/tipoAtendimento',
        name: 'Tipo de Atendimento',
        i18n: 'Tipo de Atendimento',
      },
      {
        url: '/perfis',
        name: 'Perfil de Usuário',
        i18n: 'Perfil de Usuário',
      },
      {
        url: '/contasBancarias',
        name: 'Contas Bancárias',
        i18n: 'Contas Bancária',
      },
      {
        url: '/carteiraCobranca',
        name: 'Carteira de Cobrança',
        i18n: 'Carteira de Cobrança',
      },
      {
        url: '/permissoes',
        name: 'Permissões',
        i18n: 'Permissões',
      },
      {
        url: '/mensageria',
        name: 'Mensageria',
        i18n: 'Mensageria',
      },
      {
        url: '/programaAfiliados',
        name: 'Programa de Afiliados',
        i18n: 'Programa de Afiliados',
      },
      {
        url: '/fornecedor',
        name: 'Fornecedor',
        i18n: 'Fornecedor',
      },
    ],
  },
  /*=---------- CONFIGURAÇÕES ----------=*/
  {
    url: null,
    name: 'Configurações',
    i18n: 'MenuLevel2p2',
    icon: 'SettingsIcon',
    submenu: [
      {
        url: '/produtos',
        name: 'Produto',
        i18n: 'Produto',
      },
      {
        url: '/contrato',
        name: 'Contrato',
        i18n: 'Contrato',
      },
      {
        url: '/campanha',
        name: 'Campanha',
        i18n: 'Campanha',
      },
      {
        url: '/tipoPagamento',
        name: 'Tipo de Pagamento',
        i18n: 'Tipo de Pagamento',
      },
      {
        url: '/beneficios',
        name: 'Benefícios / Coberturas',
        i18n: 'Benefícios / Coberturas',
      },
      {
        url: '/tipoFotos',
        name: 'Tipo de Foto',
        i18n: 'Tipo de Foto',
      },
      {
        url: '/restricoes',
        name: 'Restrições',
        i18n: 'Restrições',
      },
      {
        url: '/integracaoSGA',
        name: 'Integração SGA',
        i18n: 'Integração SGA',
      },
      {
        url: '/status',
        name: 'Status',
        i18n: 'Status',
      },
      {
        url: '/integracoes',
        name: 'Integrações',
        i18n: 'Integrações',
      },
    ],
  },
  /*=---------- TABELAS ----------=*/
  {
    url: null,
    name: 'Tabelas',
    i18n: 'MenuLevel2p2',
    icon: 'ListIcon',
    submenu: [
      {
        url: '/simulador',
        name: 'Simulador',
        i18n: 'Simulador',
      },
      {
        url: '/grupoVeiculos',
        name: 'Grupo de Veículos',
        i18n: 'Grupo de Veículos',
      },
      {
        url: '/tabelas',
        name: 'Tabelas',
        i18n: 'Tabelas',
      },
      {
        url: '/blackList',
        name: 'Black List',
        i18n: 'Black List',
      },
      {
        url: '/listRastreadores',
        name: 'Lista Rastreadores',
        i18n: 'Lista Rastreadores',
      },
      {
        url: '/listParticipacoes',
        name: 'Lista Participações',
        i18n: 'Lista Participaçãões',
      },
    ],
  },
];
